const initialState = {
    result: []
};

const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SEND_ANALYTIC_EVENT':
            return {
                ...state,
                result: action.payload
            };
        default:
            return state;
    }
};

export default analyticsReducer;